
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { tap } from "rxjs/operators";
import { SettingsName } from "../class/SettingsName";
import { SessionService } from "./session.service";

export interface IAccountSettingsContent {
    VideoRetentionDays?: IIntegerSetting;
    DisableLiveView?: IBooleanSetting;
    DisableNonEventDownloads?: IBooleanSetting;
    DisableInternalCameras?: IBooleanSetting;
    EnableVideoRedaction?: IBooleanSetting;
    EnableVideoMute?: IBooleanSetting;
}

export interface IIntegerSetting extends ValueSetting<number> { }
export interface IBooleanSetting extends ValueSetting<boolean> { }

interface ValueSetting<T> {
    Value: T;
}

@Injectable({
    providedIn: 'root'
})
export class AccountSettingsService {

    constructor(
        private readonly httpClient: HttpClient,
        private readonly sessionService: SessionService
    ) { }

   getDefaultAccountSettings(invalidateCache: boolean = false): Promise<IAccountSettingsContent> {

        const options = { params: {} as HttpParams }

        options.params["minsToLive"] = 30;
        options.params["invalidateCache"] = invalidateCache;

       return lastValueFrom(this.httpClient.get<IAccountSettingsContent>(`/api/accountsettings/default`, options));
    }

    getAccountSettings(invalidateCache: boolean = false): Promise<IAccountSettingsContent> {

        const accountSettings = this.sessionService.getItem(SettingsName.AccountSettings)

        if (accountSettings) {
            return Promise.resolve(accountSettings)
        }

        const options = { params: {} as HttpParams }

        options.params["minsToLive"] = 30;
        options.params["invalidateCache"] = invalidateCache;

        return lastValueFrom(this.httpClient.get<IAccountSettingsContent>(`/api/accountsettings`, options).pipe(
            tap(settings => {
                this.sessionService.setItem(SettingsName.AccountSettings, settings);
            })
        ));
    }

    getAccountSettingsByAccountId(accountId: number, invalidateCache: boolean = false): Promise<IAccountSettingsContent> {

        const options = { params: {} as HttpParams }

        options.params["minsToLive"] = 30;
        options.params["invalidateCache"] = invalidateCache;
        options.params["accountId"] = accountId;

        return lastValueFrom(this.httpClient.get<IAccountSettingsContent>(`/api/accountsettings`, options));
    }

    addOrUpdateAccountSettings(accountSettings: IAccountSettingsContent): Promise<void> {

        const options = { params: {} as HttpParams }

        this.sessionService.setItem(SettingsName.AccountSettings, accountSettings)

        return lastValueFrom(this.httpClient.post<void>(`/api/accountsettings`, accountSettings, options));
    }
}
